/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_TitleInputs */

const en_gc_editor_title = /** @type {(inputs: Gc_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft online. Your workbook, your way.`)
};

const zh_gc_editor_title = /** @type {(inputs: Gc_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线 GridCraft，让表格跟随你的思路。`)
};

/**
* | output |
* | --- |
* | "GridCraft online. Your workbook, your way." |
*
* @param {Gc_Editor_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_title = /** @type {((inputs?: Gc_Editor_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_title(inputs)
	return zh_gc_editor_title(inputs)
});
export { gc_editor_title as "gc.editor.title" }